<div class="ss-share-dialog">
  <div class="ss-share-dialog-head">
    <mat-icon class="ss-share-dialog-icon">share</mat-icon>
    <h2 class="ss-share-dialog-title">Share dashboard</h2>
    <button
      type="button"
      class="ss-share-dialog-close"
      aria-label="Close"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="ss-share-dialog-note">
    <mat-icon class="ss-share-dialog-note-icon">visibility</mat-icon>
    Anyone with this link can <strong>view</strong> this dashboard. They cannot
    edit it.
  </p>

  <div class="ss-share-dialog-linkrow">
    <input
      type="text"
      class="ss-share-dialog-input"
      [value]="data.shareLink"
      readonly
      (focus)="$any($event.target).select()"
      aria-label="Read-only share link"
    />
    <button
      type="button"
      class="primary-action ss-share-dialog-copy"
      (click)="copyShareLink()"
    >
      <mat-icon>{{ shareLinkCopied ? 'check' : 'content_copy' }}</mat-icon>
      {{ shareLinkCopied ? 'Copied' : 'Copy' }}
    </button>
  </div>

  <div class="ss-share-dialog-divider">
    <span>Give a user access</span>
  </div>

  <p class="ss-share-dialog-note ss-share-dialog-note-muted">
    <mat-icon class="ss-share-dialog-note-icon">person_add</mat-icon>
    Enter a user's email to add this dashboard to their account. It will appear
    in their dashboard list.
  </p>

  <div class="ss-share-dialog-linkrow">
    <input
      type="email"
      class="ss-share-dialog-input"
      placeholder="user@example.com"
      [(ngModel)]="grantEmail"
      [disabled]="granting"
      (keyup.enter)="grantAccess()"
      aria-label="User email to grant access"
    />
    <button
      type="button"
      class="primary-action ss-share-dialog-copy"
      [disabled]="granting || !grantEmail.trim()"
      (click)="grantAccess()"
    >
      <mat-icon>{{ granting ? 'hourglass_empty' : 'person_add' }}</mat-icon>
      {{ granting ? 'Sharing…' : 'Save' }}
    </button>
  </div>

  <p
    class="ss-share-dialog-grant-message"
    *ngIf="grantMessage"
    [class.is-success]="grantStatus === 'success'"
    [class.is-error]="grantStatus === 'error'"
  >
    <mat-icon>{{ grantStatus === 'success' ? 'check_circle' : 'error_outline' }}</mat-icon>
    {{ grantMessage }}
  </p>

  <div class="ss-share-dialog-actions">
    <button
      type="button"
      class="secondary-action ss-share-dialog-preview"
      (click)="openSharePreview()"
    >
      <mat-icon>open_in_new</mat-icon>
      Open preview
    </button>
    <button
      type="button"
      class="secondary-action ss-share-dialog-done"
      (click)="close()"
    >
      Close
    </button>
  </div>
</div>
